<template>
  <div>
    <div>
      <top-menu 
        :backVisible="true"
        :homeVisible="true"
        :aboutVisible="false"
      >
      </top-menu>
    </div>
    <div>
      <v-container fluid class="ma-0 pa-0 mt-6">
        <v-row dense>
          <v-col justify="center" class="ma-0 pa-0">
            <v-card class="ma-0 pa-0" flat>
              <v-card-title class="justify-center headline font-weight-black ma-0 pa-0 mb-4" dense >
                <v-container class="ma-0 pa-0">
                  <v-row dense no-gutters>
                    <v-col cols="1" class="text-left ma-0 pa-0">
                      <v-icon v-if="departToldData.apt_shortest_rwy !=null && record.depart_airport != '' && record.depart_airport != undefined" large class="red--text" @click="ShowDisclaimer=true">mdi-alert-circle-outline</v-icon>
                    </v-col>
                    <v-col cols="10" class="text-center">
                      <span class="font-weight-black blue--text text--darken-4 title text-center">TOLD Calculator</span>
                    </v-col>
                    <v-col cols="1" class="text-right">
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-title>
              <v-card-text>
                <v-form v-model="valid" ref="main">
                  <v-container class="ma-0 pa-0">
                    <v-row dense>
                      <v-col>
                        <v-autocomplete
                          :hint="'*Aircraft'"
                          persistent-hint
                          :items="aircraft"
                          :rules="[rules.required]"
                          @change="getWeightRanges($event);weightDisabled=false"
                          outlined
                          dense
                          item-text="displayname"
                          item-value="tailnumber"
                          menu-props="auto"
                          placeholder="Select"
                          v-model="record.tailnumber"
                        ></v-autocomplete>
                      </v-col>
                      <v-col>
                        <v-text-field
                          :hint="'*Takeoff Weight'"
                          persistent-hint=""
                          v-trimmed
                          v-uppercase
                          :disabled="weightDisabled"
                          dense
                          v-model="record.weight"
                          :rules="[rules.required, rules.isNumber, rules.weightRange ]"
                          outlined
                          placeholder=" "
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col>
                        <v-autocomplete
                          :hint="'*Departure Airport'"
                          persistent-hint
                          :items="airports"
                          :rules="[rules.required]"
                          outlined
                          dense
                          item-text="displayname"
                          item-value="ident"
                          menu-props="auto"
                          placeholder="Select"
                          v-model="record.depart_airport"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="6">
                        <v-text-field
                          :disabled="(record.depart_airport ==='') ? true : false"
                          :hint="'*OAT (\xB0' + departOatType + ')'"
                          persistent-hint
                          v-trimmed
                          v-uppercase
                          dense
                          v-model="departCalcTemp"
                          outlined
                          :rules="[rules.required, rules.isTemperature, rules.tempRange]"
                          @input="calcDepartOAT($event)"
                          placeholder=" "
                          append-icon="mdi-help-circle-outline"
                          @click:append="ShowTempHelp=true"
                        ></v-text-field>
                      </v-col>

                        <v-col cols="6">
                          <v-text-field
                            :hint="'*Baro'"
                            persistent-hint
                            :disabled="(record.depart_airport ==='') ? true : false"
                            v-uppercase
                            v-trimmed
                            dense
                            v-model="record.depart_baro"
                            outlined
                            :rules="[rules.required, rules.isNumber, rules.baroFormat, rules.baroRange]"
                            placeholder=" "
                          ></v-text-field>
                        </v-col>
                    </v-row>

                    <!-- Longest Runway - Departure -->
                    <PerfData v-if="departToldData.apt_longest_rwy !=null && departToldData.apt_longest_rwy !='' && record.depart_airport != '' && record.depart_airport != undefined" id="departLongRwy" rwytype="longest" :data="departToldData" :airport="record.depart_airport"></PerfData>


                    <!--   SHORT RWY - DEPARTURE -->
                    <PerfData v-if="departToldData.apt_shortest_rwy !=null && departToldData.apt_shortest_rwy !='' && record.depart_airport != '' && record.depart_airport != undefined" id="departShortRwy" rwytype="shortest" :data="departToldData" :airport="record.depart_airport"></PerfData>

                    <v-row >
                      <v-col class="text-center pr-1">
                        <br />
                        <div><v-btn small class="mr-2" color="primary" @click="getToldData()">Calculate</v-btn>  <v-btn small class="ml-2" color="primary" @click="$refs.main.reset();record=default_record;departToldData=default_departToldData">Clear</v-btn></div>
                      </v-col>
                    </v-row>

                    <v-row v-if="departToldData.apt_shortest_rwy !=null && record.depart_airport != '' && record.depart_airport != undefined">
                      <v-col class="text-center pr-1">
                        <v-btn small text color="primary" @click="ShowLegend=true">View Legend</v-btn>
                      </v-col>
                    </v-row>

                  </v-container>
                </v-form>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>


      <Disclaimers :visible="ShowDisclaimer" @close="ShowDisclaimer=false;"></Disclaimers>
      <Legend :visible="ShowLegend" @close="ShowLegend=false;"></Legend>
      <TempHelp :visible="ShowTempHelp" @close="ShowTempHelp=false;"></TempHelp>
    </v-container>
  </div>

    <!-- Begin - Loading Data Modal -->
    <v-dialog
      v-model="isLoading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Loading Data...
          <v-progress-linear
            indeterminate
            rounded
            color="white"
            class="mb-0"
            height="20px"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End - Loading Data Modal -->

  </div>   
</template>

<script>

  import Disclaimers from '@/components/told/Disclaimers';
  import TempHelp from '@/components/told/TempHelp';
  import PerfData from '@/components/told/PerformanceData'
  import Legend from '@/components/told/Legend'

  export default {
    name: 'ToldMain',
    components: {
      Disclaimers,
      TempHelp,
      PerfData,
      Legend
    },
    data () {
      return {
        rules:{
          required: value => !!value || 'Required.',
          isNumber: value => isNaN(value) != true || 'Must be a number.',
          isTemperature: value => {
            value = (value === undefined || value === null) ? "" : value;
            var actualTemp;
            var result;
            if(value.charAt(value.length-1).toUpperCase() === "F" || value.charAt(value.length-1).toUpperCase() === "C")
            {
              actualTemp = value.substring(0,value.length-1);
              result = isNaN(actualTemp) != true || 'Must be a number (##, ##C, ##F).'
            }
            else
            {
              actualTemp = value;
              result = isNaN(actualTemp) != true || 'Must be a number (##, ##C, ##F).'
            }

            return result;

          },
          baroFormat: value => {
            const pattern = /^\d{2}\.\d{2}$/
            return pattern.test(value) || 'Required format ##.##'
          },
          baroRange: value => (value >= 25.00 && value <= 32.00) || 'Must be between 25.00 and 32.00',
          dewpointRange: value => {
            value = (value === undefined || value === null) ? "" : value;
            var actualTemp;
            var result;
            if(value.charAt(value.length-1).toUpperCase() === "F")
            {
              actualTemp = value.substring(0,value.length-1);
              result = (actualTemp >= -130 && actualTemp <= 203) || 'Must be between -130 and 95 for farenheit'
            }
            else if(value.charAt(value.length-1).toUpperCase() === "C")
            {
              actualTemp = value.substring(0,value.length-1);
              result = (actualTemp >= -90 && actualTemp <= 95) || 'Must be between -90 and 95 for celcius or add an F for farenheit'
            }
            else
            {
              actualTemp = value;
              result = (actualTemp >= -90 && actualTemp <= 95) || 'Must be between -90 and 95 for celcius or add an F for farenheit'
            }

            return result;

          },
          tempRange: value => {
            value=value+"";
            var actualTemp;
            var result;
            if(value.charAt(value.length-1).toUpperCase() === "F")
            {
              actualTemp = value.substring(0,value.length-1);
              result = (actualTemp >= 32 && actualTemp <= 104) || 'Must be between 32 and 104 for farenheit'
            }
            else if(value.charAt(value.length-1).toUpperCase() === "C")
            {
              actualTemp = value.substring(0,value.length-1);
              result = (actualTemp >= 0 && actualTemp <= 40) || 'Must be between 0 and 40 for celcius or add F for farenheit'
            }
            else
            {
              actualTemp = value;
              result = (actualTemp >= 0 && actualTemp <= 40) || 'Must be between 0 and 40 for celcius or add F for farenheit'
            }

            return result;
          },
          weightRange: value => (value >= this.selACEmptyWeight && value <= this.selACMGW) || 'Must be between ' + this.selACEmptyWeight + ' and ' + this.selACMGW
        },
        ShowTempHelp:false,
        ShowLegend: false,
        ShowDisclaimer:false,
        weightDisabled:true,
        valid: false,
        isLoading: false,
        airports:[],
        aircraft:[],
        httpResponse:null,
        departCalcTemp: null,
        departCalcDew: null,
        departOatType:"C",
        departDewType:"C",
        departToldData: {
          model: null,
          max_gross_weight: null,
          input_baro: null,
          input_weight: null,
          input_dewpoint: null,
          input_airport: null,
          baro_correction: null,
          dewpoint_correction: null,
          airport_elevation: null,
          pressure_alt_adj_for_rounding: null,
          calculated_pa: null,
          chart_used_for_calcs: null,
          pa_used_for_takeoff_chart: null,
          pa_used_for_landing_chart: null,
          temp_used_for_charts: null,
          apt_longest_rwy_ft: null,
          apt_longest_rwy: null,
          apt_shortest_rwy_ft: null,
          apt_shortest_rwy: null,
          takeoffdistance: null,
          landingdistance: null,
          takeoffdistancewithsafety: null,
          landingdistancewithsafety: null,
          totalgroundrolldistance: null,
          overweight: null,
          aptlongrwysafe: null,
          aptshortrwysafe: null,
          paoverlimit: null
        },
        default_departToldData: {
          model: null,
          max_gross_weight: null,
          input_baro: null,
          input_weight: null,
          input_dewpoint: null,
          input_airport: null,
          baro_correction: null,
          dewpoint_correction: null,
          airport_elevation: null,
          pressure_alt_adj_for_rounding: null,
          calculated_pa: null,
          chart_used_for_calcs: null,
          pa_used_for_takeoff_chart: null,
          pa_used_for_landing_chart: null,
          temp_used_for_charts: null,
          apt_longest_rwy_ft: null,
          apt_longest_rwy: null,
          apt_shortest_rwy_ft: null,
          apt_shortest_rwy: null,
          takeoffdistance: null,
          landingdistance: null,
          takeoffdistancewithsafety: null,
          landingdistancewithsafety: null,
          totalgroundrolldistance: null,
          overweight: null,
          aptlongrwysafe: null,
          aptshortrwysafe: null,
          paoverlimit: null
        },
        selACEmptyWeight: null,
        selACMGW: null,
        record: {
          wing: '',
          depart_airport:'',
          depart_oat: '',
          depart_baro:'',
          depart_dewpoint:0,
        },
        default_record: {
          wing: '',
          depart_airport:'',
          depart_oat: '',
          depart_baro:'',
          depart_dewpoint:0,
        }
      }
    },
    mounted() {
      this.getAirportList('CA');
      this.getAircraftList();
      this.setBackButtonVisibility(true);
      this.setHomeButtonVisibility(true);
    },
    methods: {
      calcDepartOAT(val) {
        var result = this.calcTemp(val);
        this.record.depart_oat = result

        var input=val+"";
        var checkChar = (input.charAt(input.length-1)).toUpperCase();

        switch(checkChar){
          case "F":
            {this.departOatType = checkChar}
            break;
          case "C":
            {this.departOatType = checkChar}
            break;
           default:
             {this.departOatType = "C"}
             break;
        }
      },
      calcDepartDew(val) {
        var result = this.calcTemp(val);
        this.record.depart_dewpoint = result

        var input=val+"";
        var checkChar = (input.charAt(input.length-1)).toUpperCase();

        switch(checkChar){
          case "F":
            {this.departDewType = checkChar}
            break;
          case "C":
            {this.departDewType = checkChar}
            break;
           default:
             {this.departDewType = "C"}
             break;
        }
      },
      getWeightRanges(tailnum) {
        const result = this.aircraft.filter(ac => ac.tailnumber === tailnum )
        this.selACEmptyWeight = result[0].emptyweight
        this.selACMGW = result[0].mgw
      },
      getAirportList(req_state) {

        this.isLoading = true;

        var obj = {
          wing: this.selWing,
          state: req_state
        }

        this.$https.post(this.$vars.BaseUrl + this.$vars.GetAirportListRoute, obj, this.$vars.config)
        .then(response => {
          this.httpResponse = response;
          this.airports = response.data;
          this.isLoading = false;
        })
        .catch(e => {
          console.log(e); // eslint-disable-line no-console
          this.isLoading = false;
        });
      },
      getAircraftList() {

        this.isLoading = true;

        var obj = this.record

        obj.wing = this.selWing

        //console.log(obj); // eslint-disable-line no-console

        this.$https.post(this.$vars.BaseUrl + this.$vars.GetAircraftListRoute, obj, this.$vars.config)
        .then(response => {
          this.httpResponse = response;
          this.aircraft = response.data;
          this.isLoading = false;
        })
        .catch(e => {
          console.log(e); // eslint-disable-line no-console
          this.isLoading = false;
        });
      },
      getToldData() {

        this.$refs.main.validate();

        if(this.valid === true)
        {

          this.isLoading = true;

          var departObj = {
              wing: this.selWing,
              tailnumber: this.record.tailnumber,
              airport: this.record.depart_airport,
              baro: this.record.depart_baro,
              temp: this.record.depart_oat,
              weight: Math.ceil(this.record.weight),
              dewpoint: this.record.depart_dewpoint
          }

        //console.log(departObj);

        this.$https.post(this.$vars.BaseUrl + this.$vars.GetToldDataRoute, departObj, this.$vars.config)
          .then(response => {
            this.httpResponse = response;
            this.departToldData = response.data[0];
            this.isLoading = false;
          })
          .catch(e => {
            console.log(e); // eslint-disable-line no-console
            this.isLoading = false;
          });
        }
      },
      calcTemp(temp) {
        var input=temp+"";
        var finalResult="";

        var checkChar = (input.charAt(input.length-1)).toUpperCase();
        var actualTemp = "";

        if(checkChar === 'F')
        {
          actualTemp = input.substring(0,input.length-1);
          finalResult = Math.ceil(((actualTemp - 32) * 5/9));

        }
        else if(checkChar === 'C')
        {
          actualTemp = input.substring(0,input.length-1);
          finalResult = Math.ceil(actualTemp)
        }
        else
        {
          actualTemp = input
          finalResult = Math.ceil(actualTemp);

        }

        return finalResult;
      }
    }
  }
</script>
